import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { fadeUp, LOGO_DIAMOND } from "@/lib/site";

function Counter({ to, suffix = "", duration = 1800 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.1 });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start;
    let raf;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * to));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration]);

  return (
    <span ref={ref}>
      {val.toLocaleString("hr-HR")}
      {suffix}
    </span>
  );
}

const STATS = [
  { to: 5000, suffix: "+", label: "generiranih upita", desc: "Stvarni upiti pacijenata kroz Meta oglase." },
  { to: 20, prefix: "1–", suffix: " €", label: "cijena po upitu", desc: "Ovisno o vrijednosti i vrsti usluge klinike." },
  { to: 10, suffix: "", label: "klijenata godišnje", desc: "Namjerno malo — fokus na temeljitosti i kvaliteti." },
];

export default function Results() {
  return (
    <section id="rezultati" className="relative z-10 border-y border-[#222] bg-[#0a0a0a] py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="mb-16 flex items-center gap-3">
          <img src={LOGO_DIAMOND} alt="" className="diamond-bullet" />
          <span className="eyebrow">Rezultati</span>
        </motion.div>

        <div className="grid grid-cols-1 gap-px md:grid-cols-3">
          {STATS.map((s, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              custom={i}
              className="flex flex-col gap-3 py-6"
            >
              <div className="font-display text-6xl font-black uppercase tracking-tighter text-[#50C878] md:text-8xl">
                {s.prefix || ""}
                <Counter to={s.to} suffix={s.suffix} />
              </div>
              <h3 className="font-display text-lg font-extrabold uppercase tracking-wide text-white">{s.label}</h3>
              <p className="max-w-xs text-sm leading-relaxed text-white/50">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
